import { create } from 'zustand'
import type { SessionContext, PatientContext } from './bridge'

interface AppStore {
  session: SessionContext | null
  context: PatientContext | null
  activeTab: 'chart' | 'mse' | 'emr' | 'careplan'
  isSaving: boolean
  lastSaved: Date | null
  setSession: (s: SessionContext) => void
  setContext: (c: PatientContext) => void
  setActiveTab: (t: AppStore['activeTab']) => void
  setIsSaving: (v: boolean) => void
  setLastSaved: (d: Date) => void
}

export const useAppStore = create<AppStore>((set) => ({
  session: null,
  context: null,
  activeTab: 'chart',
  isSaving: false,
  lastSaved: null,
  setSession: (s) => set({ session: s }),
  setContext: (c) => set({ context: c }),
  setActiveTab: (t) => set({ activeTab: t }),
  setIsSaving: (v) => set({ isSaving: v }),
  setLastSaved: (d) => set({ lastSaved: d }),
}))
